module.exports = __webpack_public_path__ + "static/img/noLeave2.f94eadb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/noLeave2.png
// module id = 6mub
// module chunks = 2